import script from "./EmailConfirmPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailConfirmPage.vue?vue&type=script&setup=true&lang=js"

import "./EmailConfirmPage.vue?vue&type=style&index=0&id=03cfd069&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cfd069"]])

export default __exports__